(ns portfolio.core
  "Application entrypoint.

  Wiring:
    init! → detect initial language (URL > localStorage > default :en) →
    initialize app-db → mount Reagent root → install the
    IntersectionObserver scroll-spy that highlights the active nav link."
  (:require [reagent.dom.client :as rdc]
            [re-frame.core :as rf]
            [portfolio.events :as events]
            portfolio.subs
            [portfolio.scroll-spy :as scroll-spy]
            [portfolio.views :as views]))

(def ^:private section-ids ["top" "about" "projects" "contact"])
(def ^:private storage-key "portfolio.lang")

(defn- lang-from-url []
  (let [params (js/URLSearchParams. (.. js/window -location -search))
        v     (.get params "lang")]
    (case v "pt" :pt "en" :en nil)))

(defn- lang-from-storage []
  (try
    (case (.getItem js/localStorage storage-key)
      "pt" :pt "en" :en nil)
    (catch :default _ nil)))

(defn- initial-lang []
  ;; English is the default; navigator.language is intentionally ignored
  ;; so first-time visitors land on EN regardless of browser locale.
  ;; User-driven choices (URL ?lang=, the nav toggle) override.
  (or (lang-from-url)
      (lang-from-storage)
      :en))

(defonce ^:private root (atom nil))

(defn ^:dev/after-load mount! []
  (when @root
    (rdc/render @root [views/app])))

(defn init! []
  (let [lang (initial-lang)]
    (rf/dispatch-sync [::events/initialize lang])
    ;; Apply the chosen language to <html lang>, <title>, and persist it.
    (rf/dispatch-sync [::events/set-lang lang]))
  (let [el (.getElementById js/document "app")]
    (reset! root (rdc/create-root el))
    (mount!)
    (js/requestAnimationFrame
     #(scroll-spy/install! section-ids))))
